import { useEffect, useState } from 'react';
import { ACSApi, ToastStateHandler } from '../../../api';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';
import { TotalEarningsByClientDto } from '../../../commonTypes/acs';

const useHttpGetClientTotalEarnings = (clientId: string) => {
    const api: ACSApi = useContainer(ACSApi);
    const toastHandler = useContainer(ToastStateHandler);
    const [isReady, setIsReady] = useState(false);
    const [data, setData] = useState<TotalEarningsByClientDto | null>(null);
    const { t } = useTranslation('newNotifications');

    const getEarnings = (id: string) => {
        if (!id || id.trim() === '') {
            setIsReady(true);
            return;
        }

        const { exec, abort } = api.getClientTotalEarnings({
            params: { clientId: id },
            onSuccess: res => {
                setData(res.body);
            },
            onError: error => {
                console.error('Error fetching client total earnings:', error);
                toastHandler.push('error', t('common.error'), t('common.somethingWentWrong'));
            },
            onFinally: () => setIsReady(true),
        });

        exec();
        return abort;
    };

    useEffect(() => {
        if (clientId && clientId.trim() !== '') {
            getEarnings(clientId);
        } else {
            setIsReady(true);
        }
    }, [clientId]);

    return { isReady, data, getEarnings };
};

export default useHttpGetClientTotalEarnings;
